import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { MultiSelectFormField } from '@/components/shared/components/NewContextForms/MultiSelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { AllowedAssetTypeOptions } from '@/constants/AllowedAssetTypeOptions';

interface CreateAgentForm extends FormGridOptions {}

export const CreateAgentForm = ({ fieldVariant, fullWidth }: CreateAgentForm) => {
  return (
    <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth} numberOfFieldsInFirstColumn={3}>
      <TextFormField label={'AGENT_NAME'} name={'name'} />
      <TextFormField label={'AGENT_EMAIL'} name={'email'} />
      <MultiSelectFormField
        label={'ALLOWED_ASSET_TYPES'}
        name={'allowedAssetTypes'}
        selectOptions={AllowedAssetTypeOptions}
      />
    </FormGridContainer>
  );
};
